module.exports = __webpack_public_path__ + "static/media/SO2330F2.9f26dfe0.png";